"use client";

import { Sidebar } from "components/ui/v2/sidebar";

interface SidebarV2Props {
  readonly render?: boolean;
}

const SidebarV2 = ({ render = true }: SidebarV2Props) => {
  return <Sidebar render={render} />;
};

export default SidebarV2;
